// extracted by mini-css-extract-plugin
module.exports = {"artistListWrapper":"ArtistsTab_artistListWrapper__1GHIf","artistGridContainer":"ArtistsTab_artistGridContainer__bpghL"};